import { type Viewer, type Primitive, type Cartesian2, defined, GeoJsonDataSource } from 'cesium'
import { GeoJsonPrimitiveLayer, Subscriber } from 'cesium-extends'
import { LayerPopupCtrl } from '../LayerPopupCtrl'
import EventEmitter from 'eventemitter3'
import type { BaseLayerI } from '.'
export type BaseLayerEvent = {
  destroy(): void
  mounted(viewer: Viewer): void
  layerShow(): void
  layerHide(): void
}
export abstract class BaseLayer<EventTypes = {}>
  extends EventEmitter<EventTypes & BaseLayerEvent>
  implements BaseLayerI
{
  abstract layername: string
  abstract key: string
  protected layer = new GeoJsonPrimitiveLayer()
  protected datasource = new GeoJsonDataSource()
  mounted: any
  constructor() {
    super()
  }
  abstract render(): Promise<void>
  protected _subscriber?: Subscriber
  protected popupCtrl = LayerPopupCtrl.getInstance()
  protected _viewer?: Viewer
  /**挂载到地图 */
  mount(viewer: Viewer) {
    viewer.scene.primitives.add(this.layer.primitiveCollection)
    viewer.dataSources.add(this.datasource)
    this._viewer = viewer
    // @ts-ignore
    this.emit('mounted', viewer)
  }

  destroyLayer() {
    this.layer.destroy()
    this._subscriber?.destroy()
    // @ts-ignore
    this.emit('destroy')
  }
  protected isRender = false
  show() {
    if (!this.isRender) {
      this.render()
      this.isRender = true
    }
    this.datasource.show = true
    this.layer.show = true
    // @ts-ignore
    this.emit('layerShow')
  }
  hide() {
    this.layer.show = false
    this.datasource.show = false
    // @ts-ignore
    this.emit('layerHide')
  }

  protected contains(p: Primitive | undefined) {
    if (!p) return false
    return this.layer.primitiveCollection.contains(p)
  }
  /**根据屏幕坐标获取primitive */
  protected pickByScreenXY(position: Cartesian2, viewer: Viewer) {
    const pickedObj = viewer.scene.pick(position)
    if (!defined(pickedObj)) return
    if (!this.contains(pickedObj.primitive)) return
    const item = this.layer.getFeatureItemById(pickedObj.id)
    return item
  }
}
